import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import ContactFormMenu from '@ep/components/ContactForm/ContactFormMenu';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import TextField from '@ep/components/TextField';
import { Body, H2Medium, Subhead2 } from '@ep/components/Typography';
import theme from '@ep/theme';
import React, { useState } from 'react';

interface formProps {
  type: string;
  data: object;
}
interface CardProps {
  setCardState: ({ header, icon, type, card }) => void;
  formState: formProps;
  setFormState: ({ type, data }) => void;
}

const CardContainer = styled.div`
  display grid;
  grid-template-columns: 1fr 4fr 1fr;
  grid-template-rows: 1fr 6fr 1fr;
  height: 100%;
`;

const Content = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-column: 2;
  grid-row: 2;
`;

const StyledSubhead = styled(Subhead2)`
  padding-right: 6rem;
`;

const StyledButton = styled(Button)`
  margin-top: 5rem;
`;

const StyledTextField = styled(TextField)`
  grid-column: 2;
  margin-top: 0.25rem;
  .MuiFilledInput-input {
    height: 30px;
  }
  .MuiFilledInput-multiline {
    height: 70px;
    padding: 0.25rem 0.5rem;
    .MuiFilledInput-input {
      height: 70px;
    }
  }
  ${theme.mediaQueries.mobile} {
    grid-column: 1;
  }
`;

// const StyledH2Medium = styled(H2Medium)`
//   margin-top: 1.5rem;
//   margin-bottom: 2rem;
//   text-align: center;
//   font-size: 2rem;
//   ${theme.mediaQueries.mobile} {
//     font-size: 1.4rem;
//   }
// `;

const StyledBody = styled(Body)`
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.7rem;
  ${theme.mediaQueries.mobile} {
    font-size: 1.2rem;
  }
`;

const StyledBodyBold = styled(Body)`
  font-size: 1.2rem;
  font-weight: bold;
`;

const LinksContainer = styled.div`
  display: grid;
  /*grid-template-columns: 1fr 1fr;*/
  max-width: 35rem;
  text-align: left;
`;

const LinksColumnLeft = styled.div`
  grid-column: 1;
  display: flex;
  flex-direction: column;
`;
const LinksColumnRight = styled.div`
  grid-column: 2;
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  font-size: 1.5rem;
  font-family: ${theme.typography.primaryFont.light};
  color: ${theme.colors.oceanBlue};
  ${theme.mediaQueries.mobile} {
    font-size: 1.2rem;
  }
`;

const Form = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${theme.breakpoints.optimalMobile + 400}px) {
    margin-top: 1.5rem;
    display: block;
  }
`;

const PSCard2 = ({ setCardState, formState, setFormState }: CardProps) => {
  return (
    <CardContainer>
      <Content>
        <StyledBody>
          Please click the link below to go directly to our Support Center.
        </StyledBody>
        <LinksContainer>
          <LinksColumnLeft>
            <StyledSeeMoreLink
              label="EP Support Center"
              to="https://www.ep.com/support/"
              // onClick={() => {
              //   dataLayer.push({
              //     event: 'Contact link click - ' + `EP Support Center`,
              //   });
              // }}
            />
            {/* <StyledSeeMoreLink
              label="AssetHub"
              to="https://support.synconset.com/category/7e9j3qg4rq-asset-hub"
              onClick={() => {
                dataLayer.push({ event: 'Contact link click - ' + `AssetHub` });
              }}
            />
            <StyledSeeMoreLink
              label="Movie Magic products (live chat available)"
              to="https://entertainmentpartners.my.site.com/s/product-support-movie-magic#contentTop"
              onClick={() => {
                dataLayer.push({
                  event:
                    'Contact link click - ' +
                    `Movie Magic Products (live chat available)`,
                });
              }}
            />
            <StyledSeeMoreLink
              label="SmartAccounting"
              to="https://entertainmentpartners.my.site.com/s/SmartAccounting"
              onClick={() => {
                dataLayer.push({
                  event: 'Contact link click - ' + `SmartAccounting`,
                });
              }}
            />
            <StyledSeeMoreLink
              label="SmartPO"
              to="https://entertainmentpartners.my.site.com/s/smartpo"
              onClick={() => {
                dataLayer.push({ event: 'Contact link click - ' + `SmartPO` });
              }}
            />
            <StyledSeeMoreLink
              label="SmartStart"
              to="https://entertainmentpartners.my.site.com/s/SmartStart"
              onClick={() => {
                dataLayer.push({
                  event: 'Contact link click - ' + `SmartStart`,
                });
              }}
            />
            <StyledSeeMoreLink
              label="SmartTime"
              to="https://entertainmentpartners.my.site.com/s/SmartTime"
              onClick={() => {
                dataLayer.push({
                  event: 'Contact link click - ' + `SmartTime`,
                });
              }}
            />
            <StyledSeeMoreLink
              label="SyncOnSet"
              to="https://support.synconset.com/"
              onClick={() => {
                dataLayer.push({
                  event: 'Contact link click - ' + `SyncOnSet`,
                });
              }}
            /> */}
          </LinksColumnLeft>
        </LinksContainer>
        <StyledBody>For all other inquiries, continue below.</StyledBody>
        <StyledButton
          label="Continue"
          onClick={() => {
            setCardState({
              header: 'Product Support',
              icon: 'ProductSupportWhite',
              type: 'PSCard',
              card: 3,
            });
          }}
        />
      </Content>
    </CardContainer>
  );
};

const PSCard3 = ({ setCardState, formState, setFormState }: CardProps) => {
  interface InfoProps {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    memo: string;
  }

  const [infoData, setInfoData] = useState<InfoProps>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    memo: '',
  });
  const [interest, setInterest] = useState('none');

  const menuOptions = [
    {
      label: 'Accounting - Smart Accounting',
      short: 'SmartAccounting',
      value: 'SmartAccounting',
    },
    {
      label: 'Accounting - Classic Vista',
      short: 'Classic Vista',
      value: 'Classic Vista',
    },
    {
      label: 'Accounting - Global Vista',
      short: 'Global Vista',
      value: 'Global Vista',
    },
    {
      label: 'Accounting - Vista 5',
      short: 'Vista 5',
      value: 'Vista 5',
    },
    {
      label: 'Accounting - SmartPO',
      short: 'SmartPO',
      value: 'SmartPO',
    },
    {
      label: 'Accounting - VPO',
      short: 'VPO',
      value: 'VPO',
    },
    {
      label: 'AssetHub',
      short: 'AssetHub',
      value: 'AssetHub',
    },
    {
      label: 'Canada - EPLive',
      short: 'EPLive',
      value: 'EPLive',
    },
    {
      label: 'Canada - EPOL',
      short: 'EPOL',
      value: 'EPOL',
    },
    {
      label: 'Canada - EP Residency',
      short: 'Residency',
      value: 'EP Residency',
    },
    {
      label: 'Central Casting Portal',
      short: 'Central Casting Portal',
      value: 'Central Casting Portal',
    },
    {
      label: 'Training / eLearning',
      short: 'eLearning',
      value: 'eLearning',
    },
    {
      label: 'Movie Magic Budgeting New',
      short: 'Budgeting New',
      value: 'Movie Magic SAAS',
    },
    {
      label: 'Movie Magic Budgeting Legacy',
      short: 'Budgeting Legacy',
      value: 'MMB Legacy',
    },
    {
      label: 'Movie Magic Scheduling',
      short: 'Scheduling',
      value: 'MMS v6',
    },
    {
      label: 'My EP US',
      short: 'My EP US',
      value: 'MyEP US',
    },
    {
      label: 'My EP Canada',
      short: 'My EP CN',
      value: 'MyEP Canada',
    },
    {
      label: 'EP Store',
      short: 'EP Store',
      value: 'MyEP Store',
    },
    {
      label: 'Production Portal',
      short: 'Production Portal',
      value: 'Production Portal',
    },
    {
      label: 'Residuals - Portal',
      short: 'Residuals Portal',
      value: 'SmartResiduals: Portal',
    },
    {
      label: 'Residuals - Triggers',
      short: 'Residuals Triggers',
      value: 'SmartResiduals: Triggers',
    },
    {
      label: 'Residuals - Historical Data',
      short: 'Residuals Historical',
      value: 'RHD',
    },
    {
      label: 'SmartHub / Scenechronize',
      short: 'SmartHub, Scenechronize',
      value: 'SmartHub POA Project',
    },
    {
      label: 'SmartStart',
      short: 'SmartStart',
      value: 'SmartStart',
    },
    {
      label: 'SmartTime',
      short: 'SmartTime',
      value: 'SmartTime',
    },
    {
      label: 'SyncOnSet',
      short: 'SyncOnSet',
      value: 'SyncOnSet',
    },
    {
      label: 'Other',
      short: 'Other',
      value: 'Other – Specify in Subject',
    },
  ];

  const highlightField = (fieldName) => {
    if (fieldName != 'interest') {
      !infoData[fieldName]
        ? (document.getElementsByName(fieldName)[0].style =
            'border: 3px solid ' + theme.colors.mediumRed)
        : (document.getElementsByName(fieldName)[0].style =
            'border: 0px solid white');
    } else {
      interest == 'none'
        ? (document.getElementById('productSupportInterestMenu').style =
            'border: 3px solid ' + theme.colors.mediumRed)
        : (document.getElementById('productSupportInterestMenu').style =
            'border: 1px solid ' + theme.colors.darkGray);
    }
  };

  const highlightEmail = () => {
    document.getElementsByName('email')[0].style =
      'border: 3px solid ' + theme.colors.mediumRed;
  };

  const handleBlur = (event) => {
    const { name } = event.target;
    highlightField(name);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInfoData({ ...infoData, [name]: value });
  };

  const handleSubmit = () => {
    var email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (email.test(infoData.email)) {
      if (
        interest != 'none' &&
        infoData.firstName &&
        infoData.lastName &&
        infoData.email &&
        infoData.memo
      ) {
        setFormState({
          ...formState,
          data: {
            ...formState.data,
            interest: interest,
            // START SALESFORCE FIELDS
            debug: '0',
            debugEmail: 'mgalletti@ep.com',
            orgid: '00Di0000000g6Hf',
            retURL: 'https://www.ep.com/thank-you/',
            '00N1Y00000IfCFN':
              interest === 'AssetHub' || interest === 'SyncOnSet'
                ? ''
                : interest,
            name: infoData.firstName + ' ' + infoData.lastName,
            email: infoData.email,
            '00Ni000000GGP1o': infoData.phone,
            description: infoData.memo,
            subject: 'EP.com Request - ' + interest,
            case_origin: 'Website Contact Us',
            // END SALESFORCE FIELDS
          },
        });
        setCardState({
          header: `Thank You`,
          icon: '',
          type: 'submitting',
          card: 1,
        });
      } else {
        highlightField('interest');
        highlightField('firstName');
        highlightField('lastName');
        highlightField('email');
        highlightField('memo');
      }
    } else {
      highlightEmail();
    }
  };

  return (
    <CardContainer>
      <Content>
        <Form>
          <Subhead2 style={{ gridColumn: 1 }}>
            Product support needed for:*
          </Subhead2>
          <ContactFormMenu
            options={menuOptions}
            action={setInterest}
            menuId="productSupportInterestMenu"
          />
          <Subhead2 style={{ gridColumn: 1 }}>First name:*</Subhead2>
          <StyledTextField
            name="firstName"
            value={infoData.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Last name:*</Subhead2>
          <StyledTextField
            name="lastName"
            value={infoData.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Email:*</Subhead2>
          <StyledTextField
            name="email"
            value={infoData.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Phone:</Subhead2>
          <StyledTextField
            name="phone"
            value={infoData.phone}
            onChange={handleChange}
          />
          <Subhead2 style={{ gridColumn: 1 }}>
            Tell us how we can help:*
          </Subhead2>
          <StyledTextField
            multiline
            rows={3}
            name="memo"
            value={infoData.memo}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Please provide Product Name and Version, details of your request/issue and urgency level."
          />
        </Form>
        <StyledButton label="Submit" onClick={handleSubmit} />
      </Content>
    </CardContainer>
  );
};

export { PSCard2, PSCard3 };
